import { DTOMatchFilterPoolStatusRequest } from 'src/apis/dto/DTOMatchFilterPoolStatusRequest';
import { DTOMatchFilterPoolStatusResponse } from 'src/apis/dto/DTOMatchFilterPoolStatusResponse';
import type { DTORealtimeMatchCountResponse } from 'src/apis/dto/DTORealtimeMatchCountResponse';
import { MatchFilter } from 'src/types/Match';

import type { APIClientType } from '.';

export interface MatchServiceType {
  /**
   * 아자르 실시간 매치 카운트 조회
   *
   * 최근 n분 내의 전체 매치 카운트를 조회합니다. (n은 설정에 따라 변경될 수 있음)
   */
  getRealtimeMatchCount: () => Promise<DTORealtimeMatchCountResponse>;

  /**
   * Vividi 실시간 매치 카운트 조회
   *
   * 최근 n분 내의 전체 매치 카운트를 조회합니다. (n은 설정에 따라 변경될 수 있음)
   */
  getRealtimeMatchCountForVividi: () => Promise<DTORealtimeMatchCountResponse>;

  /**
   * 유저가 사용 가능한 매칭 필터 목록을 반환한다.
   *
   * 클라이언트는 로그인 직후, 그리고 유저 본인의 위치가 변경되거나, 특정 유료 필터의 가격이 변경되는 등 갱신이 필요한 시점에 호출해야 한다.
   *
   * @return 매칭 필터 목록
   */
  listMatchFilters: () => Promise<MatchFilter[]>;

  /**
   * 매치 필터의 원활도를 조회하는 API
   */
  listMatchFilterPoolStatus: (
    data: DTOMatchFilterPoolStatusRequest
  ) => Promise<DTOMatchFilterPoolStatusResponse>;
}

export class MatchService implements MatchServiceType {
  private client: APIClientType;

  constructor(customClient: APIClientType) {
    this.client = customClient;
  }

  public getRealtimeMatchCount = async () => {
    return this.client.call<DTORealtimeMatchCountResponse, void>({
      method: 'GET',
      path: '/api/v1/match/realtime-count',
    });
  };

  public getRealtimeMatchCountForVividi = async () => {
    return this.client.call<DTORealtimeMatchCountResponse, void>({
      method: 'GET',
      path: '/api/v1/match/realtime-count/vividis',
    });
  };

  public listMatchFilters = async () => {
    return this.client.call<MatchFilter[], void>({
      method: 'GET',
      path: '/api/v1/match/filters',
    });
  };

  public listMatchFilterPoolStatus = async (data: DTOMatchFilterPoolStatusRequest) => {
    return this.client.call<DTOMatchFilterPoolStatusResponse, DTOMatchFilterPoolStatusRequest>({
      method: 'POST',
      path: '/api/v1/match/filters/pool-status',
      data,
    });
  };
}
